import {SvgIcon, useTheme} from '@mui/material';

export default function MarrigeServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1397_2304)'} = props;
	const theme = useTheme();
	// @ts-ignore
	const first = theme.palette.primary[400];
	// @ts-ignore
	const second = theme.palette.primary[600];
	return (
		<SvgIcon width="26" height="24" viewBox="0 0 26 24" fill="none">
			<path opacity="0.4"
			      d="M20.0987 0.461829C20.0441 0.325498 19.95 0.208636 19.8284 0.126317C19.7068 0.0439987 19.5634 9.24271e-07 19.4165 0H13.539C13.3921 9.24271e-07 13.2487 0.0439987 13.1271 0.126317C13.0055 0.208636 12.9114 0.325498 12.8568 0.461829L12.062 2.44898H20.8936L20.0987 0.461829ZM18.5839 14.9388C18.5839 13.2386 18.1128 11.6467 17.295 10.2857H16.4778C15.6248 10.2857 14.8248 10.5167 14.1367 10.919C15.0756 11.9952 15.6451 13.4017 15.6451 14.9388C15.6451 18.3147 12.8986 21.0612 9.52265 21.0612C6.14673 21.0612 3.4002 18.3147 3.4002 14.9388C3.4002 12.1869 5.22528 9.85347 7.72853 9.08473C8.56647 7.83703 9.65985 6.78151 10.9363 5.98805C10.4687 5.91447 9.99603 5.87752 9.52265 5.87755C4.52624 5.87755 0.461426 9.94237 0.461426 14.9388C0.461426 19.9352 4.52624 24 9.52265 24C14.5191 24 18.5839 19.9352 18.5839 14.9388Z"
			      fill={color}/>
			<path
				d="M18.2366 6.04956L20.6722 3.91846H12.2833L14.7188 6.04956C10.5614 6.87075 7.4165 10.5442 7.4165 14.9389C7.4165 16.639 7.88754 18.231 8.70535 19.5919H9.52263C10.3756 19.5919 11.1756 19.361 11.8637 18.9587C10.9248 17.8824 10.3553 16.4759 10.3553 14.9389C10.3553 11.5629 13.1018 8.81642 16.4777 8.81642C19.8536 8.81642 22.6002 11.5629 22.6002 14.9389C22.6002 17.6907 20.7751 20.0242 18.2719 20.7929C17.4339 22.0406 16.3405 23.0961 15.0641 23.8896C15.5317 23.9632 16.0044 24.0001 16.4777 24.0001C21.4741 24.0001 25.539 19.9353 25.539 14.9389C25.539 10.5442 22.394 6.87075 18.2366 6.04956Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1397_2304" x1="20.4575" y1="2.31731e-06" x2="-0.533743" y2="0.9045"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor={first}/>
					<stop offset="1" stopColor={second}/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
